import {
    Box,
    BoxProps,
    Button,
    ButtonProps,
    Chip,
    Grid,
    GridProps,
    Typography,
    useTheme,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    IconButton,
    TextField,
    LinearProgress,
    IconButtonProps,
    FormControlProps,
    DialogTitleProps,
    Link,
    CircularProgress,
    ListItemButton,
    ListItemText,
    FormControl,
    MenuItem,
    Select,
    SelectChangeEvent,
    Autocomplete,
    List,
    ListItem,
    ListItemProps,
    SvgIconProps,
} from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import EastIcon from "@mui/icons-material/East";
import EmailIcon from "@mui/icons-material/Email";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

import * as Styles from "pages/employee/certificates/certificateDetails/certificateDetails.styles";
import { useParams } from "react-router-dom";
import * as certificateService from "services/certificate-service";
import * as attachmentService from "services/attachment-service";
import * as authenticationService from "services/AuthenticationService";
import * as connectiveService from "services/connective-service";
import * as departmentService from "services/department-service";
import * as applicationService from "services/application-service";
import * as companyService from "services/company-service";
import * as userService from "services/identityUser-service";
import { AxiosError } from "axios";
import dayjs, { Dayjs } from "dayjs";
import { useNavigate } from "react-router-dom";
import FileUpload, { FileUploadType } from "components/formsUI/FileUpload";
import { Message } from "components/messages/message";
import { statusStyleCertificate } from "utilities/colorHelper";
import { ExpandLess, ExpandMore } from "@mui/icons-material";
import { request } from "http";
import OutOfServiceModal from "./modals/outOfService.modal";
import ClearIcon from "@mui/icons-material/Clear";
import { useAuthContext } from "contexts/authContext";
import Collapse from "components/formsUI/Collapse/Collapse";
import { statusStyleApplication } from "utilities/colorHelper";
import PositiveSignModal from "./modals/positiveSign.modal";

interface IProps {
    showMessage: MessageBox;
}

const CertificateDetails = (props: IProps) => {
    const { showMessage } = props;
    const { certificateId: certificateId } = useParams();
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();
    const { user, checkAuth } = useAuthContext();

    const [showErrorMessage, setShowErrorMessage] = React.useState(false);
    const [errorMessage, setErrorMessage] = React.useState("");
    const [errorNotFound, setErrorNotFound] = React.useState(false);
    const [errorResend, setErrorResend] = React.useState(false);
    const [errorRevoked, setErrorRevoked] = React.useState(false);
    const [errorPositive, setErrorPositive] = React.useState(false);
    const [isLoading, setIsLoading] = React.useState(true);
    const [resendInProgress, setResendInProgress] = React.useState(false);
    const [departments, setDepartments] = React.useState<string[]>([]);
    const [orgnisationDisabled, setOrgnisationDisabled] =
        React.useState<boolean>(false);
    const [files, _setFiles] = React.useState<FileUploadType[]>([]);

    let [certificate, setCertificate] =
        React.useState<CertificateWithDetails>();

    const setFiles = (files: FileUploadType[]): void => {
        const correspondenties = files.filter(
            (file) => file.type === "Correspondentie",
        );
        const vertrouwelijk = files.filter(
            (file) => file.type === "Vertrouwelijkheidsovereenkomst",
        );
        const signedFile = files.filter((file) => file.type === "Attest");
        console.log(files);
        _setFiles([...signedFile, ...vertrouwelijk, ...correspondenties]);
    };

    const showError = (message: string) => {
        setErrorMessage(message);
        setShowErrorMessage(true);
    };

    const fetchCertificate = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorNotFound(false);
        setCertificate(undefined);
        setIsLoading(true);
        if (certificateId && certificate === undefined) {
            certificateService
                .getCertificateWithDetails(certificateId)
                .then((res: CertificateWithDetails) => {
                    console.log(res);
                    const temp = { ...res };
                    temp.status = getStatus(res);
                    temp.application.applicant.outOfServiceDate =
                        res.application.applicant.outOfServiceDate;
                    setIsLoading(false);
                    setCertificate(temp);
                })
                .catch((error: AxiosError<Error>) => {
                    console.log(error);
                    setIsLoading(false);
                    if (error.response?.status === 404) {
                        showError(
                            `${t("certificateWithDetail.errorNotFound")}`,
                        );
                        setErrorNotFound(true);
                    } else {
                        showError(`${t("certificateWithDetail.errorServer")}`);
                    }
                });
        } else {
            showError(`${t("certificateWithDetail.errorNotFound")}`);
            setErrorNotFound(true);
        }
    };

    const getStatus = (certificate: CertificateWithDetails) => {
        const dateToday = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            new Date().getDate(),
        );
        // const outOfServiceDate = dayjs(
        //     certificate.application.applicant.outOfServiceDate,
        // ).startOf("day");

        if (certificate.isRevoked) {
            return "Ingetrokken";
        } else if (
            !certificate.isRevoked &&
            new Date(certificate.application.dateTo) < dateToday
        ) {
            return "Verlopen";
        } else if (
            certificate.isApproved &&
            !certificate.isRevoked &&
            new Date(certificate.application.dateFrom) > dateToday
        ) {
            return "Toekomstig geldig";
        } else if (
            certificate.isApproved &&
            !certificate.isRevoked &&
            new Date(certificate.application.dateFrom) <= dateToday &&
            new Date(certificate.application.dateTo) >= dateToday
        ) {
            return "Geldig";
        } else if (!certificate.isApproved && !certificate.isRevoked) {
            return "Goed te keuren";
        }
        return "";
    };

    const downloadFile = () => {
        if (certificateId === undefined) return;
        certificateService
            .getSignedFile(certificateId as string)
            .then((res: Blob) => {
                if (res !== undefined) {
                    var fileUrl = URL.createObjectURL(res);
                    var fileName = "unknown.pdf";
                    if (certificate) {
                        fileName = certificate.certificateSignedFile.substring(
                            certificate.certificateSignedFile.indexOf("_") + 1,
                        );
                    }
                    const link = document.createElement("a");
                    link.href = fileUrl;
                    link.download = fileName;
                    link.click();
                }
            });
    };

    useEffect(() => {
        if (certificateId && certificate === undefined) fetchCertificate();
        if (departments.length <= 0) {
            departmentService
                .getDepartmentNames()
                .then((res: string[]) => {
                    setDepartments([...res]);
                })
                .catch((error: AxiosError<Error>) => {
                    showError(`${t("certificateWithDetail.errorServer")}`);
                });
        }
        let enable = false;
        setOrgnisationDisabled(false);
        if (checkAuth(["External"]) && !checkAuth(["Employee"])) {
            enable = true;
            setOrgnisationDisabled(true);
        }
        if (certificate !== undefined) getFiles(enable);
    }, [certificate]);

    const [openFiles, setOpenFiles] = React.useState(true);

    const handleClickInvertOpenFiles = () => {
        setOpenFiles(!openFiles);
    };

    //Resend properties
    const [openResend, setOpenResend] = React.useState(false);
    const handleOpenResend = () => setOpenResend(true);
    const handleCloseResend = () => setOpenResend(false);

    const handleConfirmResend = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorResend(false);
        setResendInProgress(true);
        if (certificate && certificateId) {
            certificateService
                .resendCertificate(certificateId)
                .then((res: any) => {
                    handleCloseResend();
                    setResendInProgress(false);
                })
                .catch((error: AxiosError<Error>) => {
                    setErrorResend(true);
                    setResendInProgress(false);
                    showError(`${t("errors.500")}`);
                });
        }
    };

    const handleCloseResendDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleCloseResend();
    };

    //Revoke properties

    const [openRevoke, setOpenRevoke] = React.useState(false);
    const handleOpenRevoke = () => setOpenRevoke(true);
    const handleCloseRevoke = () => setOpenRevoke(false);
    const [motivationRevoke, setMotivationRevoke] = React.useState("");

    const handleConfirmRevoke = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorRevoked(false);
        if (motivationRevoke !== "" && certificate && certificateId) {
            certificateService
                .updateCertificateRevoke(certificateId, motivationRevoke)
                .then((res: CertificateWithDetails) => {
                    if (certificate) {
                        const temp = res;
                        temp.status = getStatus(temp);
                        setCertificate(temp);
                        handleCloseRevoke();
                        setMotivationRevoke("");
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setErrorRevoked(true);
                    showError(`${t("requestWithDetail.errorServerUpdate")}`);
                });
        }
    };

    const handleCloseRevokeDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleCloseRevoke();
    };

    //OutOfService properties

    const [openOOS, setOpenOOS] = React.useState<boolean>(false);
    const handleOpenOOS = () => setOpenOOS(true);
    const handleCloseOOS = () => setOpenOOS(false);

    const handleCloseOOSDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleCloseOOS();
    };

    const updateCertificate = (cert: CertificateWithDetails) => {
        if (certificate) {
            const temp = { ...certificate };
            temp.application.applicant.outOfServiceDate =
                cert.application.applicant.outOfServiceDate;
            temp.status = getStatus(certificate);
            temp.statusHistories = cert.statusHistories;
            setCertificate(temp);
        }
    };

    //Positive properties

    const [openPositive, setOpenPositive] = React.useState(false);
    const [signingOvereenkomstInProgress, setSigningOvereenkomstInProgress] =
        React.useState(false);
    const [signingInProgress, setSigningInProgress] = React.useState(false);
    const handleOpenPositive = () => setOpenPositive(true);
    const handleClosePositive = () => setOpenPositive(false);

    const handleClosePositiveDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleClosePositive();
        setSigningInProgress(false);
    };

    let interval: NodeJS.Timer | undefined | boolean;

    const handleConfirmPositive = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorPositive(false);
        setSigningInProgress(true);
        console.log(certificate?.packageId);
        if (certificate && certificateId) {
            if (certificate.packageId) {
                connectiveService
                    .getPackageRemainingActionsCertificate(
                        certificate.packageId as string,
                    )
                    .then((res: string[]) => {
                        if (res.length !== 0) {
                            window.open(res[0], "_blank", "noreferrer");
                        }

                        interval = setInterval(() => {
                            checkSigningStatus();
                        }, 5000);
                    })
                    .catch((error: AxiosError<Error>) => {
                        setSigningInProgress(false);
                        setErrorPositive(true);
                        showError(`${t("requestWithDetail.errorServerSign")}`);
                    });
            } else {
                // logic to manual sign this shit
            }
        }
    };

    //Vertrouwelijkheidsovereenkomst properties

    const [errorVertrouwelijk, setErrorVertrouwelijk] = React.useState(false);
    const [openVertrouwelijk, setOpenVertrouwelijk] = React.useState(false);
    const [signingVertrouwelijkInProgress, setSigningVertrouwelijkInProgress] =
        React.useState(false);
    const handleOpenVertrouwelijk = () => setOpenVertrouwelijk(true);
    const handleCloseVertrouwelijk = () => setOpenVertrouwelijk(false);

    const handleCloseVertrouwelijkDialog = (event: any, reason: string) => {
        if (reason && reason == "backdropClick") return;
        handleCloseVertrouwelijk();
        setSigningVertrouwelijkInProgress(false);
    };

    const handleConfirmVertrouwelijk = () => {
        setErrorMessage("");
        setShowErrorMessage(false);
        setErrorVertrouwelijk(false);
        setSigningVertrouwelijkInProgress(true);
        if (certificate && certificate.application.id) {
            connectiveService
                .getConfidentialityAgreementRemainingActions(
                    certificate.application.id as string,
                )
                .then((res: string[]) => {
                    if (res.length !== 0) {
                        window.open(res[0], "_blank", "noreferrer");
                    }
                })
                .catch((error: AxiosError<Error>) => {
                    setSigningVertrouwelijkInProgress(false);
                    setErrorVertrouwelijk(true);
                    showError(`${t("requestWithDetail.errorServerSign")}`);
                });
        }
    };

    useEffect(() => {
        if (signingInProgress || signingVertrouwelijkInProgress) {
            interval = setInterval(() => {
                checkSigningStatus();
            }, 5000);
        } else {
            clearInterval(interval as NodeJS.Timer);
            clearTimeout(interval as NodeJS.Timer);
        }
    }, [signingInProgress, signingVertrouwelijkInProgress]);

    let isChecking = false;

    const checkSigningStatus = () => {
        if (!isChecking) {
            isChecking = true;
            if (signingVertrouwelijkInProgress) {
                certificateService
                    .checkPackageApplicationStatus(certificateId as string)
                    .then((res: boolean) => {
                        isChecking = false;
                        if (res && certificate && interval) {
                            setSigningVertrouwelijkInProgress(false);
                            handleCloseVertrouwelijk();
                            clearInterval(interval as NodeJS.Timer);
                            clearTimeout(interval as NodeJS.Timer);
                            fetchCertificate();
                        }
                    })
                    .catch((error: AxiosError<Error>) => {
                        isChecking = false;
                    });
            } else {
                certificateService
                    .checkPackageStatus(certificateId as string)
                    .then((res: boolean) => {
                        isChecking = false;
                        if (res && certificate && interval) {
                            certificate.certificateSignedFile = "Signed";
                            setSigningInProgress(false);
                            handleClosePositive();
                            clearInterval(interval as NodeJS.Timer);
                            clearTimeout(interval as NodeJS.Timer);
                            fetchCertificate();
                        }
                    })
                    .catch((error: AxiosError<Error>) => {
                        isChecking = false;
                    });
            }
        }
    };

    //  --- Props ---
    const wrapper: BoxProps = {
        sx: Styles.wrapper(theme),
    };

    const errorWrapper: BoxProps = {
        sx: Styles.errorWrapper(theme),
    };

    const statuswrapper: GridProps = {
        sx: Styles.statusWrapper(theme),
    };

    const statusButton: ButtonProps = {
        sx: Styles.statusButton(theme),
        variant: "contained",
    };

    const downloadCertificateWrapper: BoxProps = {
        sx: Styles.downloadCertificateWrapper(theme),
    };

    const certificateInfoWrapper: GridProps = {
        sx: Styles.certificateInfoWrapper(theme),
    };

    const statusDialogTitle: DialogTitleProps = {
        sx: Styles.statusDialogTitle(theme),
    };

    const statusDialogCancelButton: ButtonProps = {
        variant: "contained",
        sx: Styles.statusDialogCancelButton(theme),
    };

    const closeDialogIconButton: IconButtonProps = {
        sx: Styles.closeDialogIconButton(theme),
    };

    const selectProcessorWrapper: BoxProps = {
        sx: Styles.selectProcessorWrapper(theme),
    };

    const selectProcessor: FormControlProps = {
        sx: Styles.selectProcessor(theme),
    };

    const statusListItem: ListItemProps = {
        sx: Styles.statusListItem(theme),
    };

    const statusChipsWrapper: BoxProps = {
        sx: Styles.statusChipsWrapper(theme),
    };

    const statusArrowIcon: SvgIconProps = {
        sx: Styles.statusArrowIcon(theme),
    };

    const collapseGridContainer: GridProps = {
        container: true,
        item: true,
        spacing: 2,
        md: 12,
        xs: 12,
        justifyContent: "center",
        sx: {
            marginLeft: "0.75rem",
            marginBottom: "0.75rem",
        },
    };

    const getFiles = (enable: boolean = false) => {
        if (certificate !== undefined) {
            const attachements: FileUploadType[] = certificate.attachments.map(
                (attachement) => {
                    const type = attachement.type.split("/");
                    const file: FileUploadType = {
                        id: attachement.certificateId as string,
                        file: new File(
                            new Array<BlobPart>(attachement.size),
                            attachement.name,
                            { type: attachement.type },
                        ),
                        progress: 100,
                        extension: type[type.length - 1],
                        dbId: attachement.id,
                        disable: false,
                        type: attachement.fileType,
                    };
                    return file;
                },
            );
            // only do this if status is NOT "Goed te keuren" of "verlopen"
            // only do this if user is not external
            if (certificate.isApproved && !checkAuth(["External"])) {
                certificateService
                    .getSignedFile(certificateId as string)
                    .then((res: Blob) => {
                        if (res) {
                            const fileName = certificate
                                ? certificate.certificateSignedFile.substring(
                                      certificate.certificateSignedFile.indexOf(
                                          "_",
                                      ) + 1,
                                  )
                                : "";
                            const id = certificate
                                ? certificate.certificateSignedFile.substring(
                                      0,
                                      certificate.certificateSignedFile.indexOf(
                                          "_",
                                      ),
                                  )
                                : "";
                            const file: FileUploadType = {
                                id: id,
                                file: new File(
                                    new Array<BlobPart>(res),
                                    fileName,
                                    { type: "application/pdf" },
                                ),
                                progress: 100,
                                extension: "pdf",
                                dbId: id,
                                disable: true,
                                type: "Attest",
                            };
                            attachements.push(file);
                            const correspondentie = attachements.filter(
                                (file) => file.type === "Correspondentie",
                            );
                            const vertrouwelijk =
                                getVertrouwelijkFile(attachements);
                            const attest = attachements.filter(
                                (file) => file.type === "Attest",
                            );
                            setFiles([
                                attest[0],
                                ...vertrouwelijk,
                                ...correspondentie,
                            ]);
                        }
                    })
                    .catch((err) => {
                        const correspondentie = attachements.filter(
                            (file) => file.type === "Correspondentie",
                        );
                        const vertrouwelijk =
                            getVertrouwelijkFile(attachements);
                        const attest = attachements.filter(
                            (file) => file.type === "Attest",
                        );
                        if (attest.length > 0) {
                            setFiles([
                                attest[0],
                                ...vertrouwelijk,
                                ...correspondentie,
                            ]);
                        } else {
                            setFiles([...vertrouwelijk, ...correspondentie]);
                        }
                    });
            } else {
                const correspondentie = attachements.filter(
                    (file) => file.type === "Correspondentie",
                );
                const vertrouwelijk = getVertrouwelijkFile(attachements);
                var previewAttest = [
                    {
                        id: certificate.id,
                        file: new File(
                            [],
                            "Preview " + t("settings.documents.certificate"),
                            { type: "Preview" },
                        ),
                        progress: 100,
                        extension: "",
                        dbId: certificate?.packageId,
                        disable: true,
                        type: "Attest",
                        preview: true,
                    },
                ];
                setFiles([
                    ...previewAttest,
                    ...vertrouwelijk,
                    ...correspondentie,
                ]);
            }
        }
    };

    const getVertrouwelijkFile = (files: FileUploadType[]) => {
        if (
            certificate !== undefined &&
            certificate.application.hasVertrouwelijk &&
            !checkAuth(["External"])
        ) {
            var vertrouwelijk = files.filter(
                (file) => file.type === "Vertrouwelijkheidsovereenkomst",
            );
            if (vertrouwelijk.length === 0) {
                vertrouwelijk.push({
                    id: "",
                    file: new File(
                        [],
                        "Preview " + t("settings.documents.vertrouwelijk"),
                        { type: "Preview" },
                    ),
                    progress: 100,
                    extension: "",
                    dbId: certificate.application.packageId,
                    disable: true,
                    type: "Vertrouwelijkheidsovereenkomst",
                    preview: true,
                });
                return vertrouwelijk;
            }
            return vertrouwelijk;
        }
        return [];
    };

    const LocalFileUpload = () => {
        return (
            <div>
                {certificate !== undefined && (
                    <FileUpload
                        showMessage={showMessage}
                        setFilesUploaded={(e) => console.log(e)}
                        fileUploads={files}
                        isCertificates={true}
                        isCorrespondentie={true}
                        clickable={true}
                        backgroundColor="white"
                        title=""
                        disable={certificate.status !== "Ingetrokken"}
                        textUpload={t("certificateWithDetail.upload")}
                        // getFilesChanged={updateFilesChanged}
                        detailPage={true}
                    />
                )}
            </div>
        );
    };

    return (
        <Box {...wrapper}>
            {/* <ArrowBackIcon sx={{position: "absolute", padding: "10px", fontSize: "30px", "&:hover": { cursor: "pointer" }}} onClick={() => navigate(-1)}/> */}
            <Box sx={{ padding: "15px" }}>
                <h1 style={{ marginTop: "0" }}>
                    <ArrowBackIcon
                        sx={{
                            padding: "0",
                            fontSize: "25px",
                            marginRight: "5px",
                            "&:hover": { cursor: "pointer" },
                        }}
                        onClick={() => navigate(-1)}
                    />
                    {t("certificateWithDetail.title")} -{" "}
                    {certificate?.application?.applicant?.firstName}{" "}
                    {certificate?.application?.applicant?.lastName}
                </h1>
                {isLoading && <LinearProgress />}
                {showErrorMessage && !errorRevoked && !errorPositive && (
                    <Box {...errorWrapper}>
                        <Box color="error.main">
                            {errorMessage}
                            <Box sx={{ marginTop: "5px" }}>
                                {errorNotFound && (
                                    <Button
                                        color="error"
                                        variant="outlined"
                                        onClick={() => navigate(-1)}
                                    >
                                        {t("requestWithDetail.goBack")}
                                    </Button>
                                )}
                                {!errorNotFound && (
                                    <Button
                                        color="error"
                                        variant="outlined"
                                        onClick={() => navigate(0)}
                                    >
                                        {t("requestWithDetail.reload")}
                                    </Button>
                                )}
                            </Box>
                        </Box>
                    </Box>
                )}
                {certificate !== undefined && (
                    <Box>
                        <Box>
                            <Grid container {...statuswrapper}>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        mb: { xs: "10px", sm: 0 },
                                        alignSelf: "center",
                                    }}
                                >
                                    <Box>
                                        <b>{t("requestsTableHeader.status")}</b>
                                        <Chip
                                            sx={{
                                                marginLeft: "10px",
                                                backgroundColor:
                                                    statusStyleCertificate(
                                                        certificate.status,
                                                    ),
                                                color: "white",
                                            }}
                                            label={t(certificate.status)}
                                        />
                                        <br></br>
                                        {/*<Box {...selectProcessorWrapper}>
                                            <Box minWidth={100}>
                                                <b>
                                                    {t(
                                                        "requestsTableHeader.department",
                                                    )}
                                                </b>
                                            </Box>
                                            <FormControl
                                                {...selectProcessor}
                                                size="small"
                                            >
                                                <Autocomplete
                                                    options={departments}
                                                    value={
                                                        certificate.application
                                                            .department?.name
                                                    }
                                                    // disabled={certificate.status === "Geweigerd" || certificate.status === "Gunstig" || orgnisationDisabled}
                                                    disabled={
                                                        orgnisationDisabled
                                                    }
                                                    onChange={(
                                                        event: any,
                                                        value: string | null,
                                                    ) => {
                                                        changeDepartment(
                                                            event,
                                                            value,
                                                        );
                                                    }}
                                                    renderInput={(params) => (
                                                        <TextField
                                                            {...params}
                                                            sx={{
                                                                width: "150px",
                                                            }}
                                                            size="small"
                                                        />
                                                    )}
                                                    renderOption={(
                                                        props,
                                                        option,
                                                    ) => (
                                                        <MenuItem
                                                            {...props}
                                                            key={option}
                                                            value={option}
                                                        >
                                                            {option === ""
                                                                ? "Geen departement"
                                                                : option}
                                                        </MenuItem>
                                                    )}
                                                    clearIcon={
                                                        <ClearIcon
                                                            fontSize="small"
                                                            onClick={() => {
                                                                changeDepartment(
                                                                    null,
                                                                    "",
                                                                );
                                                            }}
                                                        />
                                                    }
                                                />
                                            </FormControl>
                                        </Box>*/}

                                        <Box {...downloadCertificateWrapper}>
                                            {certificate.certificateSignedFile &&
                                                certificate
                                                    .certificateSignedFile
                                                    ?.length !== 0 &&
                                                (certificate.status ===
                                                    "Geldig" ||
                                                    certificate.status ===
                                                        "Toekomstig geldig") && (
                                                    <Box
                                                        sx={Styles.iconAndTextWrapper(
                                                            theme,
                                                        )}
                                                    >
                                                        <EmailIcon />
                                                        <Link
                                                            component="button"
                                                            variant="body2"
                                                            onClick={() => {
                                                                handleOpenResend();
                                                            }}
                                                        >
                                                            {t(
                                                                "certificateWithDetail.resendCertificate",
                                                            )}
                                                        </Link>
                                                    </Box>
                                                )}

                                            {/*{(certificate.certificateSignedFile && certificate.certificateSignedFile?.length !== 0) &&
                                                <Box sx={Styles.iconAndTextWrapper(theme)}>
                                                    <DownloadIcon />
                                                    <Link component="button" variant="body2" onClick={() => { downloadFile(); }}>
                                                        {t("certificateWithDetail.download")}
                                                    </Link>
                                                </Box>
                                            }*/}
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid
                                    item
                                    xs={12}
                                    sm={6}
                                    sx={{
                                        textAlign: {
                                            sm: "end",
                                            alignSelf: "center",
                                        },
                                    }}
                                    columnSpacing={1}
                                >
                                    {(certificate.status === "Goed te keuren" ||
                                        certificate.status === "Geldig" ||
                                        certificate.status ===
                                            "Toekomstig geldig") && (
                                        <Box>
                                            {checkAuth([
                                                "GoedkeurenAttesten",
                                            ]) &&
                                                certificate.status ===
                                                    "Goed te keuren" && (
                                                    <Button
                                                        {...statusButton}
                                                        onClick={
                                                            handleOpenPositive
                                                        }
                                                        color="success"
                                                    >
                                                        {t(
                                                            "certificateWithDetail.approveButton",
                                                        )}
                                                    </Button>
                                                )}
                                            {checkAuth([
                                                "GoedkeurenAttesten",
                                            ]) &&
                                                certificate.application
                                                    .applicationSignedFile ===
                                                    "Signed" &&
                                                certificate.application
                                                    .hasVertrouwelijk && (
                                                    <Button
                                                        {...statusButton}
                                                        onClick={
                                                            handleOpenVertrouwelijk
                                                        }
                                                        color="primary"
                                                    >
                                                        {t(
                                                            "certificateWithDetail.vertrouwelijkButton",
                                                        )}
                                                    </Button>
                                                )}
                                            {/*{checkAuth(
                                                [
                                                    "BeheerAttesten",
                                                    "OpvolgenAttesten",
                                                ],
                                                false,
                                            ) &&
                                                new Date(
                                                    certificate.application.dateTo,
                                                ) > new Date() &&
                                                (certificate.application
                                                    .applicant
                                                    .outOfServiceDate ===
                                                    null ||
                                                    certificate.application
                                                        .applicant
                                                        .outOfServiceDate ===
                                                        undefined ||
                                                    new Date(
                                                        certificate.application.applicant.outOfServiceDate,
                                                    ) > new Date()) &&
                                                (certificate.status ===
                                                    "Goed te keuren" ||
                                                    certificate.status ===
                                                        "Geldig" ||
                                                    certificate.status ===
                                                        "Toekomstig geldig") && (
                                                    <Button
                                                        {...statusButton}
                                                        onClick={handleOpenOOS}
                                                        color="warning"
                                                    >
                                                        {t(
                                                            "certificateWithDetail.OOSbutton",
                                                        )}
                                                    </Button>
                                                )}*/}

                                            {checkAuth(["IntrekkenAttesten"]) &&
                                                (certificate.status ===
                                                    "Geldig" ||
                                                    certificate.status ===
                                                        "Toekomstig geldig") && (
                                                    <Button
                                                        {...statusButton}
                                                        onClick={
                                                            handleOpenRevoke
                                                        }
                                                        color="error"
                                                    >
                                                        {t(
                                                            "certificateWithDetail.revokeButton",
                                                        )}
                                                    </Button>
                                                )}
                                        </Box>
                                    )}
                                </Grid>
                            </Grid>
                        </Box>

                        <Box>
                            <Collapse
                                title={t("certificateWithDetail.historyStatus")}
                            >
                                <List component="div" disablePadding>
                                    {certificate?.statusHistories
                                        .sort(
                                            (a, b) =>
                                                new Date(
                                                    a.creationTime,
                                                ).getTime() -
                                                new Date(
                                                    b.creationTime,
                                                ).getTime(),
                                        )
                                        .map((statusHistory, index) => (
                                            <Box key={statusHistory.id}>
                                                <ListItem {...statusListItem}>
                                                    <Box>
                                                        <Box
                                                            {...statusChipsWrapper}
                                                        >
                                                            {statusHistory.statusFrom && (
                                                                <>
                                                                    <Chip
                                                                        label={t(
                                                                            statusHistory.statusFrom,
                                                                        )}
                                                                        sx={{
                                                                            backgroundColor:
                                                                                statusStyleCertificate(
                                                                                    statusHistory.statusFrom,
                                                                                ),
                                                                            color: "white",
                                                                        }}
                                                                    />
                                                                    <EastIcon
                                                                        {...statusArrowIcon}
                                                                    />
                                                                </>
                                                            )}
                                                            <Chip
                                                                label={t(
                                                                    statusHistory.statusTo,
                                                                )}
                                                                sx={{
                                                                    backgroundColor:
                                                                        statusStyleCertificate(
                                                                            statusHistory.statusTo,
                                                                        ),
                                                                    color: "white",
                                                                }}
                                                            />
                                                        </Box>
                                                        {/* <ListItemText primary={statusHistory.statusTo === "Geweigerd" && !checkAuth(["WeigerenAanvraag"]) ? "" : statusHistory.comment}
                                                            secondary={dayjs(statusHistory.creationTime).format('DD/MM/YYYY').toString() + " " + t("requestWithDetail.by") + " " + statusHistory.employeePolice?.firstName + " " + statusHistory.employeePolice?.lastName} /> */}
                                                        <ListItemText
                                                            primary={
                                                                statusHistory.statusTo ===
                                                                "Ingetrokken"
                                                                    ? certificate?.motivationRevoked
                                                                    : ""
                                                            }
                                                            secondary={`${dayjs(statusHistory.creationTime).format("DD/MM/YYYY").toString()} ${statusHistory.by ? `${t("requestWithDetail.by")} ${statusHistory.by}` : ""}`}
                                                        />
                                                    </Box>
                                                </ListItem>
                                            </Box>
                                        ))}
                                    {/* {true &&
                                            <ListItem {...statusListItem}>
                                                <Box>
                                                    <Box {...statusChipsWrapper}>
                                                        <Chip label={t('Gunstig')}
                                                            sx={{ backgroundColor: statusStyleApplication('Gunstig'), color: "white" }} />
                                                        <EastIcon {...statusArrowIcon} />
                                                        <Chip label={t('Geweigerd')}
                                                            sx={{ backgroundColor: statusStyleApplication('Geweigerd'), color: "white" }} />
                                                    </Box>
                                                    <ListItemText
                                                        primary={'Ingetrokken'}
                                                        secondary={dayjs(certificate.dateRevoked).format('DD/MM/YYYY')}
                                                    />
                                                </Box>
                                            </ListItem>
                                        }
                                        {true &&
                                            <ListItem {...statusListItem}>
                                                <Box>
                                                    <Box {...statusChipsWrapper}>
                                                        <Chip label={t('Ingediend')}
                                                            sx={{ backgroundColor: statusStyleApplication('Ingediend'), color: "white" }} />
                                                        <EastIcon {...statusArrowIcon} />
                                                        <Chip label={t('Gunstig')}
                                                            sx={{ backgroundColor: statusStyleApplication('Gunstig'), color: "white" }} />
                                                    </Box>
                                                    <ListItemText
                                                        primary={'Goed gekeurd'}
                                                        secondary={dayjs(certificate.dateApproved).format('DD/MM/YYYY')}
                                                    />
                                                </Box>
                                            </ListItem>
                                        }
                                        {true &&
                                            <ListItem {...statusListItem}>
                                                <Box>
                                                    <Box {...statusChipsWrapper}>
                                                        <Chip label={t('Ingediend')}
                                                            sx={{ backgroundColor: statusStyleApplication('Ingediend'), color: "white" }} />
                                                        <EastIcon {...statusArrowIcon} />
                                                        <Chip label={t('Toekomstig Geldig')}
                                                            sx={{ backgroundColor: statusStyleApplication('Gunstig'), color: "white" }} />
                                                    </Box>
                                                    <ListItemText
                                                        primary={'Goed gekeurd'}
                                                        secondary={dayjs(certificate.dateApproved).format('DD/MM/YYYY')}
                                                    />
                                                </Box>
                                            </ListItem>
                                        }
                                        {true &&
                                            <ListItem {...statusListItem}>
                                                <Box>
                                                    <Box {...statusChipsWrapper}>
                                                        <Chip label={t('Gunstig')}
                                                            sx={{ backgroundColor: statusStyleApplication('Gunstig'), color: "white" }} />
                                                        <EastIcon {...statusArrowIcon} />
                                                        <Chip label={t('Uit dienst')}
                                                            sx={{ backgroundColor: statusStyleApplication('Uit dienst'), color: "white" }} />
                                                    </Box>
                                                    <ListItemText
                                                        primary={'Uit dienst'}
                                                        secondary={dayjs(certificate.application.applicant.outOfServiceDate).format('DD/MM/YYYY')}
                                                    />
                                                </Box>
                                            </ListItem>
                                        }
                                        {true &&
                                            <ListItem {...statusListItem}>
                                                <Box>
                                                    <Box {...statusChipsWrapper}>
                                                        <Chip label={t('Ingediend')}
                                                            sx={{ backgroundColor: statusStyleApplication('Ingediend'), color: "white" }} />
                                                        <EastIcon {...statusArrowIcon} />
                                                        <Chip label={t('Uit dienst')}
                                                            sx={{ backgroundColor: statusStyleApplication('Uit dienst'), color: "white" }} />
                                                    </Box>
                                                    <ListItemText
                                                        primary={'Uit dienst'}
                                                        secondary={dayjs(certificate.application.applicant.outOfServiceDate).format('DD/MM/YYYY')}
                                                    />
                                                </Box>
                                            </ListItem>
                                        }
                                        <ListItem {...statusListItem}>
                                            <Box>
                                                <Box {...statusChipsWrapper}>
                                                    <Chip label={t('Opgestart')}
                                                        sx={{ backgroundColor: statusStyleApplication('Opgestart'), color: "white" }} />
                                                    <EastIcon {...statusArrowIcon} />
                                                    <Chip label={t('Ingediend')}
                                                        sx={{ backgroundColor: statusStyleApplication('Ingediend'), color: "white" }} />
                                                </Box>
                                                <ListItemText
                                                    primary={'Aangemaakt'}
                                                    secondary={dayjs(certificate.creationTime).format('DD/MM/YYYY')}
                                                />
                                            </Box> */}
                                    {/* </ListItem> */}
                                    {/* </Box> */}
                                </List>
                            </Collapse>
                        </Box>

                        {!checkAuth(["External"]) && (
                            <Box sx={{ marginBottom: "15px" }}></Box>
                        )}
                        {!checkAuth(["External"]) && (
                            <Box>
                                <Collapse title={t("requestWithDetail.files")}>
                                    <LocalFileUpload />
                                </Collapse>
                            </Box>
                        )}

                        <Box sx={{ marginBottom: "15px" }}></Box>

                        <Collapse
                            defaultOpen
                            title={t("certificateWithDetail.details")}
                        >
                            <Grid {...collapseGridContainer}>
                                <Grid item xs={12}>
                                    <div>
                                        <span>
                                            {t(
                                                "certificatesTableHeader.referenceCode",
                                            )}
                                        </span>
                                        <br />
                                        <b>{certificate.referenceCode}</b>
                                    </div>
                                </Grid>
                                {/* <Grid item xs={3}>
                                    {certificate.status === "Ingetrokken" &&
                                        <div>
                                            <span>{t("certificateWithDetail.dateRevoked")}</span>
                                            <br />
                                            <b>
                                                {dayjs(certificate.dateRevoked).format("DD/MM/YYYY")}
                                            </b>
                                        </div>
                                    }
                                </Grid> */}
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "certificatesTableHeader.startDate",
                                            )}
                                        </span>
                                        <br />
                                        {/* <b>{t("certificateWithDetail.period")}: </b> */}
                                        <b>
                                            {dayjs(
                                                certificate.application
                                                    .dateFrom,
                                            ).format("DD/MM/YYYY")}
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "certificatesTableHeader.endDate",
                                            )}
                                        </span>
                                        <br />
                                        {/* <b>{t("certificateWithDetail.period")}: </b> */}
                                        <b>
                                            {dayjs(
                                                certificate.application.dateTo,
                                            ).format("DD/MM/YYYY")}
                                        </b>
                                    </div>
                                </Grid>
                                {/* {certificate.status === "Ingetrokken" && checkAuth(["IntrekkenAttesten"]) &&
                                    <Grid item xs={12}>
                                        <div>
                                            <span>{t("certificateWithDetail.motivationRevoked")}</span>
                                            <br />
                                            <b>
                                                {certificate.motivationRevoked}
                                            </b>
                                        </div>
                                    </Grid>
                                } */}
                                {certificate.application.applicant
                                    .outOfServiceDate !== null && (
                                    <Grid item xs={12}>
                                        <div>
                                            <span>
                                                {t(
                                                    "certificateWithDetail.OOS.field",
                                                )}
                                            </span>
                                            <br />
                                            <b>
                                                {dayjs(
                                                    certificate.application
                                                        .applicant
                                                        .outOfServiceDate,
                                                ).format("DD/MM/YYYY")}
                                            </b>
                                        </div>
                                    </Grid>
                                )}
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step3.function",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {certificate.application.function}
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step3.reason",
                                            )}
                                        </span>
                                        <br />
                                        <b>{certificate.application.reason}</b>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    <div>
                                        <span>
                                            {t(
                                                "certificatesTableHeader.locations",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            <Box sx={{ marginTop: "0.1rem" }}>
                                                {certificate.application.locations.map(
                                                    (item, i) => (
                                                        <Box key={i}>
                                                            {item.name}
                                                        </Box>
                                                    ),
                                                )}
                                            </Box>
                                        </b>
                                    </div>
                                </Grid>
                            </Grid>
                        </Collapse>

                        <Box sx={{ marginBottom: "15px" }}></Box>

                        <Collapse title={t("steps.step1")}>
                            <Grid {...collapseGridContainer}>
                                {/* <Grid item xs={12}>
                                    <div>
                                        <span>{t("certificatesTableHeader.requester")}</span>
                                        <br />
                                        <b>
                                            {certificate.application.applicant?.firstName} {certificate.application.applicant?.lastName}
                                        </b>
                                    </div>
                                </Grid> */}
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.firstName",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .applicant?.firstName
                                            }
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.lastName",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .applicant?.lastName
                                            }
                                        </b>
                                    </div>
                                </Grid>

                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.birthDate",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {certificate.application.applicant
                                                ?.birthDay
                                                ? dayjs(
                                                      certificate.application
                                                          .applicant?.birthDay,
                                                  ).format("DD/MM/YYYY")
                                                : ""}
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step1.nationality",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .applicant?.nationality
                                            }
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12}>
                                    {certificate.application.applicant?.rrn && (
                                        <div>
                                            <span>
                                                {t(
                                                    "requestIndividual.step1.rrn",
                                                )}
                                            </span>
                                            <br />
                                            <b>
                                                {
                                                    certificate.application
                                                        .applicant?.rrn
                                                }
                                            </b>
                                        </div>
                                    )}
                                </Grid>
                                <Grid item xs={12} sm={12}>
                                    <div>
                                        <span>
                                            {t("requestWithDetail.adress")}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .applicant?.address?.street
                                            }{" "}
                                            {
                                                certificate.application
                                                    .applicant?.address
                                                    ?.houseNumber
                                            }{" "}
                                            {
                                                certificate.application
                                                    .applicant?.address?.box
                                            }
                                            <br />
                                            {
                                                certificate.application
                                                    .applicant?.address?.zip
                                            }{" "}
                                            {
                                                certificate.application
                                                    .applicant?.address?.city
                                            }
                                            <br />
                                            {
                                                certificate.application
                                                    .applicant?.address?.country
                                            }
                                        </b>
                                    </div>
                                </Grid>

                                <Grid item xs={12}>
                                    <div>
                                        <span>
                                            {t("requestIndividual.step1.email")}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .applicant?.email
                                            }
                                        </b>
                                    </div>
                                </Grid>
                            </Grid>
                        </Collapse>

                        <Box sx={{ marginBottom: "15px" }}></Box>

                        <Collapse title={t("steps.step2")}>
                            <Grid {...collapseGridContainer}>
                                {/* <Grid item xs={12}>
                                    <div>
                                        <span>{t("requestIndividual.step2.organizationName")}</span>
                                        <b>
                                            {certificate.application.responsible?.company?.name}
                                        </b>
                                    </div>
                                </Grid> */}
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.organizationName",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .responsible?.company?.name
                                            }
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.responsibleEmail",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .responsible?.email
                                            }
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={3}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.responsibleFirstName",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .responsible?.firstName
                                            }
                                        </b>
                                    </div>
                                </Grid>
                                <Grid item xs={12} sm={9}>
                                    <div>
                                        <span>
                                            {t(
                                                "requestIndividual.step2.responsibleLastName",
                                            )}
                                        </span>
                                        <br />
                                        <b>
                                            {
                                                certificate.application
                                                    .responsible?.lastName
                                            }
                                        </b>
                                    </div>
                                </Grid>
                            </Grid>
                        </Collapse>
                    </Box>
                )}

                <Dialog
                    fullWidth
                    onClose={handleCloseRevokeDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openRevoke}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("certificateWithDetail.revoke.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleCloseRevoke}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers>
                        <Typography variant="body2" gutterBottom>
                            {t("certificateWithDetail.revoke.info")}
                        </Typography>
                        <TextField
                            id="outlined-basic"
                            label={t("certificateWithDetail.revoke.label")}
                            variant="outlined"
                            fullWidth
                            multiline
                            placeholder={t(
                                "certificateWithDetail.revoke.infoTextfield",
                            )}
                            rows="5"
                            value={motivationRevoke}
                            onChange={(
                                event: React.ChangeEvent<HTMLInputElement>,
                            ) => {
                                setMotivationRevoke(event.target.value);
                            }}
                        />
                        {errorRevoked && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleCloseRevoke}
                        >
                            {t("requestWithDetail.cancelButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmRevoke}
                            disabled={motivationRevoke === "" ? true : false}
                        >
                            {t("requestWithDetail.confirmButton")}
                        </Button>
                    </DialogActions>
                </Dialog>

                {certificate !== undefined && (
                    <PositiveSignModal
                        open={openPositive}
                        onClose={handleClosePositiveDialog}
                        handleClosePositive={handleClosePositive}
                        signingInProgress={signingInProgress}
                        errorPositive={errorPositive}
                        errorMessage={errorMessage}
                        handleConfirmPositive={handleConfirmPositive}
                        certificate={certificate}
                        resetCert={fetchCertificate}
                        setCertificate={setCertificate}
                        showMessage={showMessage}
                    />
                )}
                {/* <Dialog
                    fullWidth
                    onClose={handleClosePositiveDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openPositive}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("certificateWithDetail.positive.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleClosePositive}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers sx={{ textAlign: "center" }}>
                        { (certificate && certificate.application && certificate.application.applicationSignedFile === "Signed") ? (
                            <Box>
                                <Typography variant="body2" gutterBottom>
                                    {t("certificateWithDetail.confidentialityAgreement")}
                                </Typography>
                                { !signingOvereenkomstInProgress &&
                                    <Button onClick={openConfidentialityAgreementToSign} variant="contained">{t("requestWithDetail.positive.signButton")}</Button>
                                }
                            </Box>
                        ) : (
                            <Typography variant="body2" gutterBottom>
                                {t("certificateWithDetail.positive.info")}
                            </Typography>
                        )}
                        {(signingInProgress === true || signingOvereenkomstInProgress) && <CircularProgress />}
                        {errorPositive && <Box color="error.main" marginTop="5px"> {errorMessage}</Box>}
                    </DialogContent>
                    <DialogActions>
                        <Button {...statusDialogCancelButton} onClick={handleClosePositive}>
                            {t("certificateWithDetail.closeButton")}
                        </Button>
                        <Button variant="contained" color="success" autoFocus onClick={handleConfirmPositive}
                            disabled={certificate?.application === undefined || certificate.application.applicationSignedFile === "Signed"}>
                            {t("certificateWithDetail.signButton")}
                        </Button>
                    </DialogActions>
                </Dialog> */}

                <Dialog
                    fullWidth
                    onClose={handleCloseVertrouwelijkDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openVertrouwelijk}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("certificateWithDetail.vertrouwelijk.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleCloseVertrouwelijk}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers sx={{ textAlign: "center" }}>
                        {
                            <Box>
                                <Typography variant="body2" gutterBottom>
                                    {t(
                                        "certificateWithDetail.vertrouwelijk.info",
                                    )}
                                </Typography>
                            </Box>
                        }
                        {signingVertrouwelijkInProgress && <CircularProgress />}
                        {errorVertrouwelijk && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleCloseVertrouwelijk}
                        >
                            {t("certificateWithDetail.closeButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmVertrouwelijk}
                            disabled={signingVertrouwelijkInProgress}
                        >
                            {t("certificateWithDetail.signButton")}
                        </Button>
                    </DialogActions>
                </Dialog>

                <Dialog
                    fullWidth
                    onClose={handleCloseResendDialog}
                    aria-labelledby="customized-dialog-title"
                    open={openResend}
                >
                    <DialogTitle {...statusDialogTitle}>
                        {t("certificateWithDetail.resend.title")}
                        <IconButton
                            {...closeDialogIconButton}
                            aria-label="close"
                            onClick={handleCloseResend}
                        >
                            <CloseIcon />
                        </IconButton>
                    </DialogTitle>

                    <DialogContent dividers sx={{ textAlign: "center" }}>
                        <Typography variant="body2" gutterBottom>
                            {t("certificateWithDetail.resend.info")}
                        </Typography>
                        {resendInProgress === true && <CircularProgress />}
                        {errorResend && (
                            <Box color="error.main" marginTop="5px">
                                {" "}
                                {errorMessage}
                            </Box>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            {...statusDialogCancelButton}
                            onClick={handleCloseResend}
                        >
                            {t("requestWithDetail.cancelButton")}
                        </Button>
                        <Button
                            variant="contained"
                            color="success"
                            autoFocus
                            onClick={handleConfirmResend}
                            disabled={resendInProgress}
                        >
                            {t("requestWithDetail.confirmButton")}
                        </Button>
                    </DialogActions>
                </Dialog>

                {certificate && (
                    <OutOfServiceModal
                        open={openOOS}
                        handleClose={handleCloseOOS}
                        onClose={handleCloseOOSDialog}
                        updateCertificate={updateCertificate}
                        dateCertificate={
                            certificate?.application?.applicant
                                ?.outOfServiceDate
                        }
                    />
                )}
            </Box>
        </Box>
    );
};

export default CertificateDetails;
